import { decode } from "@googlemaps/polyline-codec";

import { Log, TLatLngTuple } from "@ryde/shared";

/**
 * Decode an encoded polyline, or null when there is nothing to decode or the value is malformed. The three
 * places that read a polyline back (form sync, snap, rebuild) all have to survive a bad string without
 * throwing through a React effect or an event handler, so the try/catch lives here once.
 */
export const decodePolylineOrNull = (
  encodedPolyline: string | undefined,
  logMessage: string,
): TLatLngTuple[] | null => {
  if (!encodedPolyline) {
    return null;
  }

  try {
    return decode(encodedPolyline) as TLatLngTuple[];
  } catch (error) {
    Log.error(logMessage, error);
    return null;
  }
};
